import {  ValueDisplayWithLabel } from '../../components/ValueDisplay'
import LineDisplay from './LineDisplay'
import { IShiftFunction4Point } from './types'
import { FormattedMessage } from 'react-intl';

export const OperatorPanel = (props: IShiftFunction4Point) => {

    return (

        <>
             <ValueDisplayWithLabel label={<FormattedMessage id='Functions.Output' defaultMessage={'Output'}></FormattedMessage>} value={props.actSetpoint} dimension={'°C'}></ValueDisplayWithLabel>
            <LineDisplay {...props}> </LineDisplay>
        </>
    )
}

